import { db } from '@/config/firebase';

async function getDistributions(companyId, conCompanyId, conLocId, assetTypeId) {
    let assetPoolDistributions = {};

    let query = db.collection('assetPoolDistributions');
    if (companyId) {
        query = query.where('companyId', '==', companyId);
    }
    if (conCompanyId) {
        query = query.where('connectedCompanyId', '==', conCompanyId);
    }
    if (conLocId) {
        query = query.where('connectedStorageLocationId', '==', conLocId);
    }
    if (assetTypeId) {
        query = query.where('assetTypeId', '==', assetTypeId);
    }

    const querySnapshot = await query.get();
    querySnapshot.forEach(item => {
        let assetPoolDistribution = item.data();
        assetPoolDistribution.id = item.id;
        assetPoolDistributions[item.id] = assetPoolDistribution;
    });

    return assetPoolDistributions;
}

function generateQuery(filterBy) {
    let query = db.collection('assetPoolDistributions');

    if (filterBy.source && filterBy.source.companyId) {
        query = query.where("connectedCompanyId", "==", filterBy.source.companyId);
    }

    if (filterBy.source && filterBy.source.storageLocationId) {
        query = query.where("connectedStorageLocationId", "==", filterBy.source.storageLocationId);
    }


    if (filterBy.assetTypeId) {
        query = query.where("assetTypeId", "==", filterBy.source.assetTypeId);
    }

    // Static for now, used only in discrepancy report
    query = query.where("type", "==", "On-Hand");

    return query;
}

function getAssetPoolDistributionListener(filter, callback) {
    let query = generateQuery(filter);
    let listener = query.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
            callback(change.type, change.doc.data());
        });
    });
    return listener;
}


export default {
    getDistributions,
    getAssetPoolDistributionListener
}